(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("ViaFacebookCtrl", ["frameworkService", "facebookService", "badge", viaFacebookCtrl]);
    function viaFacebookCtrl(frameworkService, facebookService, badge) {
        var vm = this;
        vm.badge = badge;
        var evidence = encodeURI(vm.badge.evidence);
        var locale = frameworkService.data.selectedLanguage.culture;
        vm.src = facebookService.getShareLink(locale, evidence);
        //local = local.replace("-", "_");
        //vm.src = "https://www.facebook.com/plugins/share_button.php?locale=" + local + "&href=" + evidence + "&layout=button&size=large&mobile_iframe=true&width=100&height=28&appId";
        //vm.src = $sce.trustAsResourceUrl(vm.src);
    }
}());
